import styled from '@emotion/styled';
import { Button, Form, Input, notification } from 'antd';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import { ParameterType } from '../../../../redux/userStore/reducer';
import { ORANGE, PRIMARY, YELLOW } from '../../../../shared/colors';
import { getParameter, updateParameter } from '../../../dashboard/network';
import { Layout } from '../../../shared/Layout';

const Container = styled.div`
  height: calc(100vh - 30px);
  display: flex;
  background-color: #1c2025;
  color: white;

  .bread-crum span {
    color: white;
  }

  .ant-form-item,
  .ant-form-item-label label {
    color: white;
  }

  td.ant-table-column-sort {
    background-color: transparent !important;
  }

  th {
    background-color: ${PRIMARY} !important;
    color: white !important;
    font-weight: bold;
  }

  .odd-row {
    background-color: #757575;
    color: white;
  }

  .even-row {
    background-color: #acacac;
    color: white;
  }

  .odd-row,
  .even-row {
    &:hover > td {
      background-color: ${YELLOW} !important;
      cursor: pointer;
      color: black; /* plus lisible */
    }
  }

  .content {
    padding: 50px;
    width: 100%;
    background-color: #1c2025;
    color: white;
  }
`;

export const ParameterPage = () => {
  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;
  const [parameter, setParameter] = useState<ParameterType>();

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = () => {
    setIsLoading(true);
    getParameter(1).then(({ data: response }) => {
      setParameter(response);
      console.log(response);
      setIsLoading(false);
    });
  };

  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  form.setFieldsValue(parameter);

  return (
    <Layout>
      <Container>
        {/** Obtain 'current' values in Sidebar component */}
        <div className='content'>
          <div style={{ marginTop: 0 }}>
            <h2 style={{ color: 'white' }}>Parametres de l'application</h2>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: 5,
              }}
            >
              <Form
                layout='vertical'
                style={{
                  listStyleType: 'none',
                  background: 'rgba(220, 220, 220, 0.1)',
                  color: 'white',
                  width: '40%',
                  padding: '20px',
                }}
                form={form}
                initialValues={parameter}
                labelCol={{ span: 40 }}
                wrapperCol={{ span: 25 }}
                onFinish={async (data) => {
                  setIsLoading(true);
                  // update user
                  console.log(data);
                  await updateParameter(1, data).then(
                    ({ data, statusCode }) => {
                      if (statusCode?.toString()[0] === '2') {
                        notification.success({
                          message: 'Succès',
                          description:
                            'Les parametres ont été mis à jour avec succès',
                        });
                        setParameter(data);
                      } else {
                        notification.info({
                          message: 'Erreur',
                          description: data.message,
                        });
                      }
                      setIsLoading(false);
                    },
                  );
                }}
              >
                <Form.Item
                  label="Taux de Commission d'intermediation "
                  name='com_intermediation'
                  rules={[
                    {
                      required: true,
                      message:
                        "Entrez le taux de la commission d'intermediation",
                    },
                  ]}
                  style={{ marginBottom: 5 }}
                >
                  <Input
                    type='number'
                    placeholder='Entrez le taux de la commission'
                  />
                </Form.Item>
                <Form.Item
                  label='Taux de Commission de conservation '
                  name='com_conservation'
                  rules={[
                    {
                      required: true,
                      message:
                        'Entrez le taux de la commission de conservation',
                    },
                  ]}
                  style={{ marginBottom: 5 }}
                >
                  <Input
                    type='number'
                    placeholder='Entrez le taux de la de conservation'
                  />
                </Form.Item>
                <Form.Item
                  label='Taux de Droit de garde '
                  name='droit_garde'
                  rules={[
                    {
                      required: true,
                      message: 'Entrez le taux du Droit de garde',
                    },
                  ]}
                  style={{ marginBottom: 5 }}
                >
                  <Input
                    type='number'
                    placeholder='Entrez le taux du Droit de garde'
                  />
                </Form.Item>
                <Form.Item
                  label='Taux de Commission de courtage '
                  name='com_courtage'
                  rules={[
                    {
                      required: true,
                      message: 'Entrez le taux de la commission de courtage',
                    },
                  ]}
                  style={{ marginBottom: 5 }}
                >
                  <Input
                    type='number'
                    placeholder='Entrez le taux de la commission de courtage'
                  />
                </Form.Item>
                <Form.Item>
                  <Button
                    type='primary'
                    htmlType='submit'
                    loading={isLoading}
                    style={{
                      width: '50%',
                      backgroundColor: ORANGE,
                      borderWidth: 0,
                      borderRadius: 5,
                      marginBottom: 20,
                    }}
                  >
                    Enregistrer
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
        ;
      </Container>
    </Layout>
  );
};
